import { render, staticRenderFns } from "./dyh-imgChoose.vue?vue&type=template&id=28f4802e&scoped=true&"
import script from "./dyh-imgChoose.vue?vue&type=script&lang=js&"
export * from "./dyh-imgChoose.vue?vue&type=script&lang=js&"
import style0 from "./dyh-imgChoose.vue?vue&type=style&index=0&id=28f4802e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4802e",
  null
  
)

export default component.exports